export type VesselIconKind = 'container' | 'tanker' | 'gas' | 'wind' | 'ship'

const icons: Record<VesselIconKind, { label: string; paths: string[] }> = {
  container: { label: 'Container ship', paths: ['M3 15h18l-3 5H6z', 'M5 15V6h14v9M5 10h14M10 6v9M15 6v9'] },
  tanker: { label: 'Tanker', paths: ['M3 15h18l-3 5H6z', 'M5 15V9h4v6M9 12h11M12 12V8h5v4M7 9V5'] },
  gas: { label: 'Gas carrier', paths: ['M3 15h18l-3 5H6z', 'M5 15v-4a3 3 0 0 1 6 0v4M12 15v-4a3 3 0 0 1 6 0v4M20 15V7'] },
  wind: { label: 'Wind installation vessel', paths: ['M3 16h18l-3 4H6z', 'M6 16V4M18 16V4M10 16V7l6-3M10 7l5 5M10 7L7 3'] },
  ship: { label: 'Vessel', paths: ['M3 15l9-3 9 3-3 5H6z', 'M7 13V7h10v6M10 7V4h4v3M12 12v8'] },
}

export function vesselIconInfo(vesselType: string | null) {
  const type = vesselType?.toLowerCase() ?? ''
  let kind: VesselIconKind = 'ship'
  if (/wtiv|wind|installation/.test(type)) kind = 'wind'
  else if (/lng|lpg|gas|ethane|ammonia|nh3/.test(type)) kind = 'gas'
  else if (/container|teu/.test(type)) kind = 'container'
  else if (/tanker|crude|oil|chemical|shuttle/.test(type)) kind = 'tanker'
  return { kind, ...icons[kind] }
}

// Only fixed SVG paths are interpolated; no vessel-provided text enters marker HTML.
export function vesselIconSvg(vesselType: string | null): string {
  const { paths } = vesselIconInfo(vesselType)
  return `<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${paths.map(d => `<path d="${d}"/>`).join('')}</svg>`
}
